import { PageComUPSAU } from '@elem/compPage/river-3-series-portable-power-station/detail/NewProductContent';
import { useRouter } from 'next/router';
import css from './ProductContent.module.scss';
import ProductCN from './ProductCN';
import ProductJp from './ProductJp';

export default function Teaser({ bundles, callbackCart }: any) {
    const { locale = 'us' } = useRouter();
    if (locale === 'cn') {
        return <ProductCN />;
    }
    if (locale === 'au') {
        return (
            <div className={css.R3Page}>
                <PageComUPSAU />
            </div>
        );
    }
    return <ProductJp bundles={bundles} callbackCart={callbackCart} />;
}
